import { useLocalization } from '@/hooks/localization'

export default function Resx ({ name, params, render }) {
  const context = useLocalization()
  if (typeof render === 'function') {
    return render(context) || null
  }
  return context.localize(name, params)
}



// WEBPACK FOOTER //
// ./src/components/Resx.js